class FetchDocumentTemplateVersion {
	constructor(
		public readonly organizationId: number,
		public readonly versionId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchDocumentTemplateVersion;
